import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Week } from "../../../components/week-picker";
import {
  CommentWeeklySummaryRequest,
  commentWeeklySummaryStateAction,
  CreateWeeklySummaryRequest,
  createWeeklySummaryStateAction,
  getCommentWeeklySummaryState,
  getNewWeeklySummaryState,
  getUpdateWeeklySummaryState,
  getWeeklySummaryState,
  UpdateWeeklySummaryRequest,
  updateWeeklySummaryStateAction,
  userWeeklySummaryStateAction,
  WeeklySummaryComment,
} from "../../../redux/features/weekly-summary-slice";
import { AppDispatch } from "../../../redux/store";
import { dateFormatter } from "../../../core/utils";
import SummarySubmitForm from "./summary-submit-form";
import { UserResponse } from "../../../redux/features/user-slice";
import SummaryCommentsList from "./summary-comments-list";
import { summaryOptions } from "../../../core/utils/constants";

interface Props {
  user: UserResponse;
  weekRange: Week;
}

export default function SummaryTab(props: Props) {
  const { user, weekRange } = props;

  const dispatch = useDispatch<AppDispatch>();
  const weeklySummary = useSelector(getWeeklySummaryState).data;
  const newWeeklySummaryState = useSelector(getNewWeeklySummaryState);
  const updateWeeklySummaryState = useSelector(getUpdateWeeklySummaryState);
  const commentWeeklySummary = useSelector(getCommentWeeklySummaryState).data;

  const [comments, setComments] = useState<WeeklySummaryComment[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>(
    summaryOptions[0]
  );

  const fetchWeeklySummary = useCallback(async () => {
    await dispatch(
      userWeeklySummaryStateAction({
        userId: user.id,
        start: dateFormatter(weekRange.firstDay, "yyyy-MM-dd"),
        end: dateFormatter(weekRange.lastDay, "yyyy-MM-dd"),
      })
    );
  }, [dispatch, user.id, weekRange]);

  const submitWeeklySummary = async (values: CreateWeeklySummaryRequest) => {
    await dispatch(createWeeklySummaryStateAction(values));
  };

  const updateWeeklySummary = async (values: UpdateWeeklySummaryRequest) => {
    await dispatch(updateWeeklySummaryStateAction(values));
  };

  const submitCommentWeeklySummary = async (
    values: CommentWeeklySummaryRequest
  ) => {
    await dispatch(commentWeeklySummaryStateAction(values));
  };

  useEffect(() => {
    fetchWeeklySummary();
  }, [fetchWeeklySummary]);

  useEffect(() => {
    if (weeklySummary) {
      setComments(weeklySummary.comments);
    }
  }, [weeklySummary]);

  useEffect(() => {
    setComments([]);
  }, [weekRange]);

  useEffect(() => {
    if (newWeeklySummaryState.data && newWeeklySummaryState.data.success) {
      fetchWeeklySummary();
    }
  }, [newWeeklySummaryState]);

  useEffect(() => {
    if (
      updateWeeklySummaryState.data &&
      updateWeeklySummaryState.data.success
    ) {
      fetchWeeklySummary();
    }
  }, [updateWeeklySummaryState]);

  useEffect(() => {
    if (commentWeeklySummary && commentWeeklySummary.success) {
      fetchWeeklySummary();
    }
  }, [commentWeeklySummary]);

  useEffect(() => {
    console.log(selectedOption);
  }, [selectedOption]);

  return (
    <div
      className="h-full grid grid-cols-6 gap-4"
      style={{
        height: "calc(100% - 69px)",
      }}
    >
      <div className="h-full col-span-4 flex flex-col overflow-hidden">
        <SummarySubmitForm
          summary={weeklySummary}
          startDate={weekRange.firstDay}
          endDate={weekRange.lastDay}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          onSubmit={(values: CreateWeeklySummaryRequest) =>
            submitWeeklySummary({ ...values, comments: comments })
          }
          onUpdate={(values: UpdateWeeklySummaryRequest) =>
            updateWeeklySummary(values)
          }
          onRefresh={fetchWeeklySummary}
        />
      </div>
      <div className="h-full col-span-2 overflow-hidden">
        <SummaryCommentsList
          user={user}
          comments={comments}
          setComments={(values: WeeklySummaryComment[]) => {
            if (weeklySummary) {
              submitCommentWeeklySummary({
                id: weeklySummary.id,
                comments: values,
              });
            } else {
              setComments(values);
            }
          }}
        />
      </div>
    </div>
  );
}
